export const it = {
  'ad.label': 'Pubblicità',
  'ad.sponsored_by': 'Sponsorizzato da {advertiser}',
  'ad.visit': 'Visita',
  'cookies.preferences': 'Preferenze cookie',
  'cookies.title': 'La tua privacy, sotto il tuo controllo',
  'cookies.description': 'Utilizziamo l\'archiviazione necessaria per il funzionamento di Albambam. Attiveremo analisi o marketing solo con il tuo permesso. Puoi revocarlo in qualsiasi momento. Consulta la',
  'cookies.privacy_link': 'Informativa sulla privacy',
  'cookies.close': 'Chiudi preferenze',
  'cookies.necessary': 'Necessari',
  'cookies.necessary_desc': 'Sessione, sicurezza, lingua e preferenze di base.',
  'cookies.analytics': 'Analisi',
  'cookies.analytics_desc': 'Misurazione anonima dell’uso per migliorare il servizio.',
  'cookies.marketing': 'Marketing',
  'cookies.marketing_desc': 'Personalizzazione pubblicitaria e misurazione delle campagne.',
  'cookies.configure': 'Configura',
  'cookies.reject': 'Rifiuta opzionali',
  'cookies.save': 'Salva selezione',
  'cookies.accept': 'Accetta tutti',
  'lang.selector_label': 'Lingua',
  'lang.changed': 'Lingua cambiata',
  'nav.home': 'Home',
  'nav.categories': 'Categorie',
  'nav.shorts': 'Shorts',
  'nav.friends': 'Amicizie',
  'nav.upload': 'Carica',
  'nav.profile': 'Profilo',
  'nav.login': 'Accedi',
  'common.signed_in': 'Accesso effettuato',
  'common.error': 'Errore',
  'topbar.search_placeholder': 'Cerca video, creatori...',
  'legal.terms': 'Termini',
  'legal.privacy': 'Privacy',
  'nav.admin': 'Amministrazione',
  'nav.logout': 'Esci',
  'admin.tab.payments': 'Pagamenti',
  'admin.payments.title': 'Pagamenti',
  'cats.title': 'Categorie',
  'cats.all': 'Tutte',
  'cats.adult_title': 'Categorie +18',
  'cats.empty': 'Nessun video in questa categoria.',
  'friends.block_confirm': 'Bloccare questo amico? Non potrete più chattare né vedervi come amici.',
  'friends.accepted': 'Ora siete amici!',
  'friends.title': 'Amicizie',
  'friends.subtitle': 'Solo chi si segue a vicenda diventa amico e può chattare in privato.',
  'friends.unread_count_label': '{n} messaggi da leggere',
  'friends.blocked_users_title': 'Utenti bloccati',
  'friends.unblock_user': 'Sblocca',
  'friends.requests_title': 'Richieste di chat',
  'friends.request_badge': 'Richiesta',
  'friends.request_accept': 'Accetta',
  'friends.request_ignore': 'Ignora',
  'friends.empty_title': 'Non hai ancora amici',
  'friends.empty_subtitle': 'Segui qualcuno e fatti seguire a tua volta per sbloccare la chat privata.',
  'friends.attach_image': 'Foto',
  'friends.shared_video_label': 'Ha condiviso un video',
  'friends.select_conversation': 'Seleziona un amico per iniziare a chattare',
  'friends.block_user': 'Blocca',
  'friends.no_messages_yet': 'Ancora nessun messaggio. Saluta!',
  'friends.message_placeholder': 'Scrivi un messaggio...',
  'section.trending': 'Tendenze',
  'section.shorts': 'Shorts',
  'section.for_you': 'Per te',
  'home.hero.badge': 'Benvenuti su Albambam',
  'home.hero.title_1': 'Video brevi.',
  'home.hero.title_2': 'Creatori veri.',
  'home.hero.subtitle': 'Guarda, condividi e guadagna. Carica i tuoi video e scopri nuovi talenti in ogni categoria.',
  'home.hero.cta_shorts': 'Guarda gli Shorts',
  'home.hero.cta_trending': 'Tendenze',
  'home.shorts.see_all': 'Vedi tutti',
  'home.empty.title': 'Ancora nessun video',
  'home.empty.subtitle': 'Quando i creatori caricheranno contenuti, appariranno qui.',
  'live.send_diamonds': 'Invia diamanti',
  'live.buy': 'Compra',
  'live.chat': 'Chat',
  'live.type_message': 'Scrivi un messaggio...',
  'live.send': 'Invia',
  'auth.success_google': 'Accesso effettuato con Google',
  'auth.fail_google': 'Sessione Google non valida',
  'auth.success_login': 'Accesso effettuato',
  'auth.success_register': 'Account creato',
  'auth.login_tab': 'Accedi',
  'auth.register_tab': 'Crea account',
  'auth.email': 'E-mail',
  'auth.password': 'Password',
  'auth.submit_login_loading': 'Accesso in corso...',
  'auth.submit_login': 'Accedi',
  'auth.name': 'Nome',
  'auth.submit_register_loading': 'Creazione...',
  'auth.submit_register': 'Crea account',
  'auth.or': 'o',
  'legal.privacy_title': 'Informativa sulla Privacy',
  'search.title': 'Risultati per «{q}»',
  'search.count': '{n} video',
  'search.empty': 'Nessun risultato.',
  'series.load_error': 'Impossibile caricare la serie',
  'series.unlocked': 'Serie sbloccata',
  'series.purchase_error': 'Impossibile avviare l\'acquisto',
  'series.restricted': 'Accesso limitato',
  'series.configure_access': 'Configura l\'accesso',
  'series.language_all': 'Tutte le lingue',
  'series.episode_count': '{n} episodi',
  'series.buy': 'Compra la serie',
  'series.filter_language': 'Filtra per lingua',
  'series.no_episodes': 'Nessun episodio ancora pubblicato.',
  'series.episode_number': 'Episodio {n}',
  'legal.terms_title': 'Termini e Condizioni',
  'lang.ca': 'Catalano',
  'lang.en': 'Inglese',
  'lang.es': 'Spagnolo',
  'lang.fr': 'Francese',
  'lang.de': 'Tedesco',
  'lang.it': 'Italiano',
  'lang.eu': 'Basco',
  'lang.gl': 'Galiziano',
  'lang.zh': 'Cinese',
  'lang.other': 'Altro',
  'lang.vi': 'Vietnamita',
  'lang.ja': 'Giapponese',
  'lang.ko': 'Coreano',
  'lang.ru': 'Russo',
  'lang.ro': 'Rumeno',
  'lang.ar': 'Arabo',
  'lang.tr': 'Turco',
  'lang.pl': 'Polacco',
  'lang.ms': 'Malese',
  'lang.ta': 'Tamil',
  'upload.series_title_error': 'Scrivi il titolo della serie',
  'upload.series_adult_category_error': 'Seleziona una categoria +18 per la serie',
  'upload.series_created': 'Serie creata',
  'upload.series_create_error': 'Impossibile creare la serie',
  'upload.err_file': 'Scegli un file video valido',
  'upload.err_title': 'Inserisci un titolo',
  'upload.series_select_error': 'Seleziona o crea una serie',
  'upload.trailer_target_error': 'Seleziona il video o la serie del trailer',
  'upload.price_error': 'Inserisci un prezzo valido di almeno 0,50 EUR.',
  'upload.adult_category_error': 'Seleziona una categoria adulta',
  'upload.success': 'Video caricato correttamente',
  'upload.title_h': 'Carica un video',
  'upload.kind': 'Tipo di pubblicazione',
  'upload.kind_video': 'Video indipendente',
  'upload.kind_episode': 'Episodio di una serie',
  'upload.kind_trailer': 'Trailer pubblico negli Shorts',
  'upload.series': 'Serie',
  'upload.series_select': 'Seleziona una serie',
  'upload.episode': 'Episodio',
  'upload.series_new_title': 'Titolo di una nuova serie',
  'upload.series_create': 'Crea serie',
  'upload.series_adult': 'Serie +18',
  'upload.series_premium': 'Serie premium',
  'upload.series_adult_category': 'Categoria +18 della serie',
  'upload.series_price': 'Prezzo per episodio e pacchetto (EUR)',
  'upload.trailer_for': 'Il trailer presenta',
  'upload.trailer_select': 'Seleziona video o serie',
  'upload.video_prefix': 'Video',
  'upload.file_label': 'File video (MP4, max 1GB)',
  'upload.file_pick': 'Clicca per scegliere un video',
  'upload.thumb_label': 'Miniatura (opzionale)',
  'upload.video_title': 'Titolo',
  'upload.description': 'Descrizione',
  'upload.category': 'Categoria',
  'upload.is_short': 'È uno Short (verticale)',
  'upload.paid_video': 'Video a pagamento',
  'upload.adult_content': 'Contenuto +18',
  'upload.video_language': 'Lingua del video',
  'upload.individual_price': 'Prezzo per guardare questo video (EUR)',
  'upload.paid_video_help': 'Lo spettatore compra l\'accesso permanente solo a questo video. Il prezzo minimo è 0,50 EUR.',
  'upload.adult_category': 'Categoria adulta',
  'upload.uploading': 'Caricamento {n}%',
  'upload.submit': 'Carica video',
  'user.followers': 'follower',
  'user.following': 'seguiti',
  'user.follow': 'Segui',
  'user.chat_open': 'Chatta',
  'user.request_sent': 'Richiesta inviata',
  'user.send_message': 'Invia messaggio',
  'user.followers_title': 'Follower',
  'user.following_title': 'Seguiti',
  'user.unfollow': 'Smetti di seguire',
  'user.request_title': 'Richiesta di chat',
  'user.request_subtitle': 'Puoi inviare solo un messaggio. Se accetta la tua richiesta, diventerete amici e potrete chattare.',
  'user.request_placeholder': 'Scrivi il tuo messaggio...',
  'user.request_send': 'Invia richiesta',
  'shorts.login_for_like': 'Accedi per mettere Mi piace',
  'watch.share_copied': 'Link copiato',
  'watch.delete_confirm': 'Eliminare questo commento?',
  'ad.skip_in': 'Salta tra {n}s',
  'ad.skip': 'Salta annuncio',
  'watch.share': 'Condividi',
  'friends.share_video': 'Condividi un video',
  'friends.send': 'Invia',
  'watch.comments': 'Commenti',
  'watch.write_comment': 'Scrivi un commento...',
  'watch.publish': 'Pubblica',
  'watch.login_to_comment': 'Accedi per commentare.',
  'watch.login_btn': 'Accedi per commentare',
  'watch.no_comments': 'Ancora nessun commento.',
  'watch.related': 'Correlati',
  'nav.trending': 'Tendenze',
  'friends.follow_option_only_follow': 'Segui',
  'friends.follow_option_friends': 'Amici',
  'watch.like': 'Mi piace',
  'watch.views_short': '{n} visualizzazioni',
  'shorts.empty.title': 'Ancora nessun Short',
  'shorts.empty.subtitle': 'Carica un video breve per inaugurare la sezione.',
  'shorts.share': 'Condividi',
  'auth.continue_google': 'Continua con Google',
  'upload.is_premium': 'Premium',
  'upload.price': 'Prezzo (€)',
  'upload.err_select': 'Scegli un video',
  'profile.upload_btn': 'Carica video',
  'profile.tab_videos': 'I miei video ({n})',
  'profile.tab_history': 'Cronologia',
  'profile.tab_recos': 'Consigliati',
  'profile.no_videos': 'Non hai ancora caricato nessun video.',
  'profile.no_history': 'Non hai ancora guardato nessun video.',
  'profile.no_recos': 'Guarda alcuni video per ricevere consigli.',
  'profile.likes': 'mi piace',
  'profile.views': 'visualizzazioni',
  'wallet.title': 'Portafoglio',
  'wallet.rate_label': 'Tariffa',
  'wallet.min_label': 'Minimo di prelievo',
  'wallet.amount_label': 'Importo da prelevare',
  'wallet.withdraw_btn': 'Richiedi prelievo',
  'wallet.history_title': 'Cronologia delle richieste',
  'wallet.success': 'Richiesta creata',
  'wallet.bad_amount': 'Importo non valido',
  'wallet.per_view': '{rate} {cur}/visualizzazione',
  'admin.title': 'Amministrazione',
  'admin.stats.users': 'Utenti',
  'admin.stats.videos': 'Video',
  'admin.stats.shorts': 'Shorts',
  'admin.stats.views': 'Visualizzazioni',
  'admin.tab.videos': 'Video',
  'admin.tab.ads': 'Annunci',
  'admin.tab.users': 'Utenti',
  'admin.tab.withdrawals': 'Prelievi',
  'admin.tab.config': 'Impostazioni',
  'admin.tab.translations': 'Lingue',
  'tbl.title': 'Titolo',
  'tbl.creator': 'Creatore',
  'tbl.category': 'Categoria',
  'tbl.type': 'Tipo',
  'tbl.views': 'Views',
  'tbl.likes': 'Likes',
  'tbl.status': 'Stato',
  'tbl.actions': 'Azioni',
  'tbl.placement': 'Posizione',
  'tbl.advertiser': 'Inserzionista',
  'tbl.impressions': 'Imp.',
  'tbl.clicks': 'Click',
  'tbl.active': 'Attivo',
  'tbl.name': 'Nome',
  'tbl.email': 'E-mail',
  'tbl.role': 'Ruolo',
  'tbl.wallet': 'Portafoglio',
  'tbl.amount': 'Importo',
  'tbl.date': 'Data',
  'tbl.user': 'Utente',
  'video.video': 'Video',
  'video.short': 'Short',
  'action.show': 'Pubblica',
  'action.hide': 'Nascondi',
  'action.delete_confirm_video': 'Eliminare il video?',
  'ad.create_h': 'Crea annuncio',
  'ad.title_label': 'Titolo',
  'ad.image_label': 'URL immagine',
  'ad.target_label': 'URL di destinazione',
  'ad.advertiser_label': 'Inserzionista',
  'ad.placement_label': 'Posizionamento',
  'ad.placement.banner': 'Banner (sito web)',
  'ad.placement.preroll': 'Pre-roll (prima del video)',
  'ad.placement.overlay': 'Overlay (nel video)',
  'ad.active': 'Attivo',
  'ad.create_btn': 'Crea',
  'ad.success_create': 'Annuncio creato',
  'ad.delete_confirm': 'Eliminare l’annuncio?',
  'users.make_admin': 'Rendi admin',
  'users.remove_admin': 'Rimuovi admin',
  'wd.approve': 'Approva',
  'wd.reject': 'Rifiuta',
  'wd.mark_paid': 'Segna pagato',
  'wd.empty': 'Nessuna richiesta',
  'cfg.title': 'Impostazioni dei pagamenti',
  'cfg.rate_label': 'Pagamento per visualizzazione ({cur})',
  'cfg.min_label': 'Minimo per prelevare ({cur})',
  'cfg.currency': 'Valuta',
  'cfg.save': 'Salva',
  'cfg.saved': 'Impostazioni salvate',
  'trans.title': 'Lingue e traduzioni',
  'trans.intro': 'Carica un file JSON con traduzioni per qualsiasi codice lingua (es. ja, pt, zh). Il file deve contenere una mappa piatta chiave → testo.',
  'trans.code_label': 'Codice lingua (es. ja, pt-BR, zh)',
  'trans.name_label': 'Nome (in quella lingua)',
  'trans.file_label': 'File JSON delle traduzioni',
  'trans.upload': 'Carica',
  'trans.uploaded': 'Traduzioni salvate',
  'trans.delete': 'Elimina',
  'trans.delete_confirm': 'Eliminare questa lingua?',
  'trans.builtin': 'Integrata',
  'trans.custom': 'Personalizzata',
  'trans.empty_custom': 'Nessuna lingua personalizzata.',
  'common.cancel': 'Annulla',
  'common.loading': 'Caricamento...',
  'common.too_fast': 'Troppo veloce, attendi un momento',
  'time.few_seconds': 'pochi secondi fa',
  'time.min': '{n} min fa',
  'time.h': '{n} h fa',
  'time.d': '{n} g fa',
  'time.w': '{n} sett fa',
  'time.mo': '{n} mesi fa',
  'time.y': '{n} anni fa',
  'brand.tagline': 'Video brevi. Creatori veri.',
  'live.section': 'In diretta',
  'live.start': 'Avvia una diretta',
  'live.end': 'Termina la diretta',
  'live.join': 'Entra in diretta',
  'live.chat_placeholder': 'Scrivi un messaggio...',
  'live.diamond': 'Diamante',
  'live.buy_access': 'Compra l\'accesso',
  'live.save_recording': 'Salva registrazione',
};
